import React from "react";

import { Outlet } from "react-router-dom";
const NoLayout = () => {
  return <Outlet />;
};

export default NoLayout;
